import { useState, useEffect, useContext } from "react";
import AppContext from "../../context";
import css from "./Report.module.css";
import Card from "../../components/Card/Card";
import backgroundCard from "../../assets/images/backgroundCardGreen.png"
import Popup from "../../components/Popup/Popup";
import ExcelUtils from "../../utils/excel";
import { AlertEntity } from "../../layouts/Alert/AlertEntity";
import { format } from "date-fns";
import { ReportDropOffEntity } from "../../entities/ReportEnity";
import { ReportService } from "../../services/report";
import FilterUtils from "../../utils/filter-utils";
import { LuImage } from "react-icons/lu";
import { VendorDropoffService } from "../../services/vendors_dropoff";
import { GuestServingEntity } from "../../entities/GuestServingEntity";
import { GuestServingsService } from "../../services/guest_servings";

export default function ReportGuestServing() {
    // ========================================= GLOBAL CONTEXT =========================================  //
    const context = useContext(AppContext);
    const contextAccessToken = context.contextAccessToken;
    const contextShowAlertFunc = context.contextShowAlertFunc;
    const contextShowLoadingFunc = context.contextShowLoadingFunc;
    const stateShowLoading = context.stateShowLoading
    // ========================================= GLOBAL CONTEXT =========================================  //


    // ========================================= STATE VIEW =========================================  //

    const [tableDataFilter, setTableDataFilter] = useState<{ [key: string]: string }>({});
    const [tableData, setTableData] = useState<GuestServingEntity[]>([]);
    const [filterDate, setFilterDate] = useState({
        start_date: format(new Date(), "yyyy-MM-dd"),
        end_date: format(new Date(), "yyyy-MM-dd")
    });

    // ========================================= STATE VIEW =========================================  //

    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    const handleGenerateExcel = async () => {
        if (tableData.length == 0) { return contextShowAlertFunc(new AlertEntity({ message: "NO DATA!", level: 3 })); }
        const column = ["tanggal", "shift", "vendor", "lokasi", "customer_name", "id_customer", "payment", "type"];
        let values: { [key: string]: string }[] = [];
        let dataForExport = tableData.filter((row) => {
            return FilterUtils.FilterTable(row, tableDataFilter)
        })
        for (let i = 0; i < dataForExport.length; i++) {
          values.push({
            tanggal: format(dataForExport[i].tanggal, "yyyy-MM-dd HH:mm:ss") ,
            shift: dataForExport[i].shift.toString(),
            vendor: dataForExport[i].vendor,
            lokasi: dataForExport[i].lokasi,
            customer_name: dataForExport[i].customer_name,
            id_customer: dataForExport[i].id_customer.toString(),
            payment: dataForExport[i].payment,
            type: dataForExport[i].type,
          })
        }
        ExcelUtils.export(`Tapping List on ${filterDate.start_date} until ${filterDate.end_date}`, column, values);
    }

    const generateData = async () => {
        contextShowLoadingFunc(true);
        try {
            const resp = await GuestServingsService.GetReportGuestServings(filterDate.start_date, filterDate.end_date)
            setTableData(resp);
            contextShowLoadingFunc(false);
        } catch (error: any) {
            contextShowAlertFunc(new AlertEntity({ message: error.toString(), level: 3 }));
            contextShowLoadingFunc(false);
        }
    };

    useEffect(() => {
        generateData();
    }, [contextAccessToken]);

    // ========================================= FUNCTIONS =========================================  //
    // ========================================= FUNCTIONS =========================================  //

    return (
        <>
            <div className="container" style={{ display: stateShowLoading ? "none" : "flex" }}>
                <Card
                    detailTitle="Report Guest Serving"
                    detailColor="var(--secondary-color)"
                    backgroundImage={backgroundCard}
                    stateShow={true}
                    detailCard={
                        <>
                            <div className={css.rowGrid} style={{ alignItems: 'end' }}>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>Start Date :</label>
                                    <input style={{ fontSize: "12px" }} type="date" value={filterDate.start_date}
                                        onChange={(event) => setFilterDate(prevState => ({
                                            ...prevState,
                                            start_date: event.target.value
                                        }))}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>End Date :</label>
                                    <input style={{ fontSize: "12px" }} type="date" value={filterDate.end_date}
                                        onChange={(event) => setFilterDate(prevState => ({
                                            ...prevState,
                                            end_date: event.target.value
                                        }))}
                                    />
                                </div>
                                <div>
                                    <div style={{ color: "white", textAlign: "left" }}>&nbsp;</div>
                                    <button className="cardButton" onClick={() => generateData()} >
                                        Refresh
                                    </button>
                                </div>
                                <div>
                                    <button className="cardButton" onClick={() => handleGenerateExcel()} >
                                        Generate Excel
                                    </button>
                                </div>
                            </div>
                            <div className={css.rowGrid} style={{ alignItems: 'end', marginTop: "1vh" }}>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>shift :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.shift ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, shift: event.target.value }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>vendor :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.vendor ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, vendor: event.target.value }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>lokasi :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.lokasi ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, lokasi: event.target.value }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>customer name :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.customer_name ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, customer_name: event.target.value }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>id_customer :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.id_customer ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, id_customer: event.target.value }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>payment :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.payment ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, payment: event.target.value }));
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "12px", color: "white", textTransform: 'uppercase', fontWeight: '600', }}>type :</label>
                                    <input style={{ fontSize: "12px" }} type="text" defaultValue={tableDataFilter.type ?? null}
                                        onChange={(event) => {
                                            setTableDataFilter((prev) => ({ ...prev, type: event.target.value }));
                                        }}
                                    />
                                </div>
                            </div>
                        </>
                    }
                />
                <div
                    style={{
                        height: "65vh",
                        overflow: "auto"
                    }}>
                    <table className="tableclickcell">
                        {tableData.length > 0 ?
                            <>
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Tanggal</th>
                                        <th>Shift</th>
                                        <th>Vendor</th>
                                        <th>Lokasi</th>
                                        <th>Customer Name</th>
                                        <th>ID Customer</th>
                                        <th>Payment</th>
                                        <th>Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.filter((row) => {
                                        return FilterUtils.FilterTable(row, tableDataFilter)
                                    })
                                        .map((row, idx) => {
                                            return <tr key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>{format(row.tanggal, "yyyy-MM-dd HH:mm:ss")}</td>
                                                <td>{row.shift == 0 ? "No Shift" : row.shift}</td>
                                                <td>{row.vendor}</td>
                                                <td>{row.lokasi}</td>
                                                <td>{row.customer_name}</td>
                                                <td>{row.id_customer}</td>
                                                <td>{row.payment}</td>
                                                <td>{row.type}</td>
                                            </tr>
                                        })}
                                </tbody>
                            </>
                            :
                            <>
                                <thead><tr><th>no data available yet!</th></tr></thead>
                            </>
                        }
                    </table>
                </div>
            </div>
        </>
    );
}
